import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const DocumentFileIcon = (props: IconProps) => (
  <Icon width="87px" height="77px" viewBox="0 0 87 77" {...props}>
    <rect width="87.71" height="8.889" x=".395" y=".37" fill="#F5F5F5" rx="2" />
    <rect width="87.71" height="8.889" x=".395" y="17.407" rx="2" />
    <rect width="87.71" height="8.889" x=".395" y="34.444" rx="2" />
    <rect width="87.71" height="8.889" x=".395" y="51.481" rx="2" />
    <path d="M.395 70.519a2 2 0 0 1 2-2h83.71a2 2 0 0 1 2 2v4.888a2 2 0 0 1-2 2H2.395a2 2 0 0 1-2-2V70.52Z" />
  </Icon>
);

export default memo(DocumentFileIcon);
